var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('all-sections',{attrs:{"crm-pipeline":_vm.crmPipeline,"crm-status":_vm.crmStatus,"crm-tags":_vm.crmTags}})}
var staticRenderFns = []

export { render, staticRenderFns }